import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=01c4c04b&scoped=true"
import script from "./Workflows.vue?vue&type=script&setup=true&lang=js"
export * from "./Workflows.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Workflows.vue?vue&type=style&index=0&id=01c4c04b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4c04b",
  null
  
)

export default component.exports